// extracted by mini-css-extract-plugin
export var cardIcon = "_8k-5";
export var cardIconUnframed = "_8k-9";
export var checkboxCard = "_8k-0";
export var checkboxCardSelected = "_8k-4";
export var disabled = "_8k-2";
export var interactive = "_8k-1";
export var outerBorder = "_8k-3";
export var spacerMedium = "_8k-8";
export var spacerSmall = "_8k-7";
export var spacerXsmall = "_8k-6";